<app-header [header-data]="headerData"></app-header>
<div *ngIf="!isLoading">
<div class="about-container container-md px-md-0 sd-claim-section">
    <h1 class="about-title">{{labelCaption['Supporting_Documents_Claims_Header']}}</h1>

    <div class="row no-gutters mb-5">
        <div class="col-12 col-md-6">
            <h2>{{supportingDocumentDetails.engagementName}}</h2>
            <h5>{{supportingDocumentDetails.engagementType}}</h5>
        </div>
    </div>
    <div class="row no-gutters mb-4">
        <div class="col-12 col-md-3">
            <label>{{labelCaption['Supporting_Documents_Claims_POD_Received_Date']}}</label>
            <p>{{supportingDocumentDetails.podReceivedDate}}</p>
        </div>
        <div class="col-12 col-md-6">
            <label>{{labelCaption['Supporting_Documents_Claims_AdjudicationStatus']}}</label>
            <p class="text-blue">{{supportingDocumentDetails.adjudicationStatusName}}</p>
        </div>
    </div>
    <div class="row no-gutters">
        <div class="col-12 col-md-3">
            <label>{{labelCaption['Supporting_Documents_Claims_DateSent']}}</label>
            <p>{{supportingDocumentDetails.dateSent}}</p>
        </div>
        <div class="col-12 col-md-6">
            <label>{{labelCaption['Supporting_Documents_Claims_SupportingDocs_status']}}</label>
            <p>{{supportingDocumentDetails.statusName}}</p>
        </div>
    </div>
    <form [formGroup]="registerForm">
        <div class="textarea-wrapper my-5">
            <div class="sd-textarea">
                <ckeditor class="ckbackground" tagName="textarea" formControlName="description" [disabled]="disableDescriptionField()" [(ngModel)]="supportingDocumentDetails.description" [config]="config" [editor]="Editor" class="text-editor"></ckeditor>
            </div>
    </div>
    </form>
    <div class="row no-gutters">
        <div class="col-12 col-md-6">
            <button type="button" (click)="closeTab()"
                class="secondary-button">{{labelCaption['Supporting_Documents_Claims_Cancel']}}</button>
        </div>
    </div>
</div>
</div>